import { struct } from 'io-ts/Decoder';

import { Id as RecipeCopyId } from '../../../whole-house/recipe-copy/Id';

export const Params = struct({
	copyId: RecipeCopyId,
});
